module.exports = __webpack_public_path__ + "img/p6.c1f13a14.png";